import { FormikField, P, Tooltip } from '@ahmdigital/ui';
import { includes } from 'lodash/fp';
import { useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';

import { PricingDrawerSchemaType } from '../../../../schema';
import { SCALES_WITH_MULTIPLE_ADULTS } from '../../../../constants';

const StyledSection = styled.section`
  flex-grow: 1;
`;

type AgeFieldProps = {
  isProductWithHospitalServices: boolean;
  hasSubmitAttempt: boolean;
  showTooltip?: boolean;
};

const AgeField = ({ showTooltip = true, isProductWithHospitalServices, hasSubmitAttempt }: AgeFieldProps) => {
  const { values } = useFormikContext<PricingDrawerSchemaType>();
  const { scale } = values;
  const hasPartner = includes(scale, SCALES_WITH_MULTIPLE_ADULTS);

  const tooltip = (
    <Tooltip>
      <P>
        Your age helps us calculate your Australian Government Rebate (AGR)
        {isProductWithHospitalServices && ' and any Youth Discount'}. The AGR applied to your policy is based on the
        oldest member’s age on your policy.
      </P>
    </Tooltip>
  );
  return (
    <StyledSection>
      <FormikField
        label="My age"
        name="age"
        size="auto"
        tooltip={showTooltip && tooltip}
        {...(hasSubmitAttempt ? { touched: hasSubmitAttempt } : {})}
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ input: { inputMode: string; pattern: string; }; type: string; touched?: true | undefined; label: string; name: string; size: string; tooltip: false | Element; }' is not assignable to type 'IntrinsicAttributes & FormikFieldProps'.
        input={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
        type="text"
      />
      {hasPartner && (
        <FormikField
          label="My partner’s age"
          name="partnerAge"
          input={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
          {...(hasSubmitAttempt ? { touched: hasSubmitAttempt } : {})}
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ type: string; touched?: true | undefined; label: string; name: string; input: { inputMode: string; pattern: string; }; }' is not assignable to type 'IntrinsicAttributes & FormikFieldProps'.
          type="text"
        />
      )}
    </StyledSection>
  );
};

export default AgeField;
